<style src="./Select.scss" lang="scss"></style>

<template lang="pug">
  .select(
    :class='{ "is-rounded": rounded }'
  )
    v-select(
      ref='vselect'
      label='label'
      @input='onChange'
      :value='selected'
      :searchable='false'
      :options='populatedOptions'
      :placeholder='placeholder'
      :components='{ OpenIndicator }'
    )
      template(
        v-slot:no-options
      )
        p {{ $l10n("NOT_FOUNDED") }}
</template>

<script>
import vSelect from "@/components/VueSelect/";

export default {
  props: {
    options: Array,
    placeholder: String,
    selected: [String, Number],
    rounded: { type: Boolean, default: true }
  },
  data() {
    return {
      OpenIndicator: {
        render: createElement =>
          createElement("span", {}, [
            createElement(
              "svg",
              {
                class: { icon: true },
                attrs: { viewBox: "0 0 9 15" }
              },
              [
                createElement("path", {
                  attrs: {
                    d: "M1 1L7.5 7.5L1 14",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }
                })
              ]
            )
          ])
      }
    };
  },
  components: {
    vSelect
  },
  methods: {
    onChange(option) {
      const { value } = option || {};

      if (value == "reset") {
        this.reset();
      } else {
        this.$emit("change", value);
      }
    },
    reset() {
      this.$refs.vselect.clearSelection();
    }
  },
  computed: {
    populatedOptions() {
      return !this.selected
        ? this.options
        : [
            {
              label: "Сбросить",
              value: "reset"
            },
            ...this.options
          ];
    },
    vSelectRef() {
      return this.$refs.vselect;
    }
  }
};
</script>
